<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Grower" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="grower"
            placeholder="Submission Grower"
            invalid-feedback="Required"
            :state="!$v.grower.$invalid"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectPotatoFieldFormGroup",
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    current_submission() {
      return this.submission(this.submissionId);
    },
    submission_potato() {
      return this.current_submission.submission_potato;
    },
    grower: {
      get() {
        return this.submission_potato.grower;
      },
      set(value) {
        this.handleSubmissionUpdate(
          {
            ...this.submission_potato,
            grower: value,
          },
          "submission_potato"
        );
      },
    },
  },
  validations: {
    grower: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
  },
};
</script>
